import React from "react";

// --- CSS --- //
import "../../styles/employee-card.css";

// --- ASSETS --- //
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const EmployeeCard = ({ name, code, status, searchQuery, isSelected, onClick, showDetails }) => {
    // Disable selection if the name is "No results found"
    const handleClick = () => {
        if (name === `No results found for '${searchQuery}'`) return; // Do nothing if it's the fallback employee
        onClick(); // Proceed with normal selection for other employees
    };

    return (
        <div
            className={`employee-container ${isSelected ? "selected" : ""}`}
            onClick={handleClick} // Use handleClick to conditionally prevent selection
        >
            <div className="employee-info-container">
                {showDetails && (isSelected ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />)}
                <p className="employee-name">{name}</p>
            </div>
            <div className="employee-info-container">
                <p className="employee-code">{code}</p>
                {showDetails && status !== undefined && (
                    status ? 
                        <CheckCircleIcon style={{color: "var(--alert-green)", marginLeft: "15px", fontSize: "25pt"}} />
                        : <CancelIcon style={{color: "var(--alert-red)", marginLeft: "15px", fontSize: "25pt"}} />
                )}
            </div>
        </div>
    );
};

export default EmployeeCard;